var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3650_373)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 150,
    r: 150,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.678 233.768H92.7656V110.168H119.744V209.825H210.678V233.768Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.067 107.743C188.354 107.743 199.128 97.0229 199.128 83.7992C199.128 70.5755 188.354 59.8555 175.067 59.8555C161.774 59.8555 151 70.5755 151 83.7992C151 97.0229 161.774 107.743 175.067 107.743Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinea);
export default __webpack_public_path__ + "static/media/linea.2a97dde4a3e61d572b3bfb5de172f892.svg";
export { ForwardRef as ReactComponent };